export default {
  table: {
    header: [
      { title: "#", id: "order" },
      { title: "คำถาม", id: "nameLocal" },
      { title: "คะแนน", id: "score" },
      { title: "ประเภท", id: "questionTypeCode" },
      { title: "UnitID", id: "unitSeq" },
      { title: " ", id: "actions" }
    ]
  },
  list: [
    {
      nameLocal: "QUESTION",
      score: "SCORE",
      questionTypeCode: "TYPE",
      unitSeq: "UNIT ID"
    }
  ],
  form: {
    filter: {
      // academicPeriodId: "",
      // periodCode: "",
      degreeId: "",
      subjectGroupId: "",
      subjectId: "",
      // subjectCode: "",
      // subjectName: "",
      // courseOutlineId: "",
      teacherId: "",
      // teacherCode: "",
    },
    input: {
      examId: null,
      subjectId: null,
      teacherId: null,
      subjectCode: null,
      teacherCode: null,
      score: 1
    },
    selectedSheet: [],
    examQuestionScoreBySheet: [],
    courseOutlineRegistrationInput: []
  }
};
